{
	"authenticatingDescription": "Please log in to your legacy account in the popup window.",
	"authenticatingTitle": "Authenticating...",
	"completeTitle": "Migration Complete",
	"couldNotComplete": "Could not complete migration. No changes were made to your account.",
	"done": "Done",
	"errorAuthFailed": "Failed to authenticate. Please try again.",
	"errorExchangeCode": "Failed to exchange authorization code.",
	"errorNetworkProblem": "There was a problem contacting the server. Please check your network connection and try again.",
	"errorServerReturned": "The server returned an error while processing the migration.",
	"errorUnexpected": "An unexpected error occurred during migration.",
	"failedTitle": "Migration Failed",
	"introDescription": "Transfer your styles and projects from your legacy Polarr Next account. You will be asked to log in to your old account to verify ownership.",
	"introNote": "This is a one-time operation. After migration, the legacy account will be locked.",
	"itemsMigrated_one": "{{count}} item migrated successfully.",
	"itemsMigrated_other": "{{count}} items migrated successfully.",
	"labelPresets": "Presets",
	"labelProjects": "Projects",
	"labelStyles": "Styles",
	"loginToLegacy": "Log in to Legacy Account",
	"migratingDescription": "Transferring your data. This may take a moment.",
	"migratingTitle": "Migrating...",
	"migrationError": "Something went wrong while processing your migration.",
	"notNeededDescription": "Your accounts already share the same data — no migration is required. You can start using your styles and projects right away.",
	"notNeededTitle": "Migration Not Needed",
	"sourceAlreadyMigratedDescription": "Your source account has already been migrated to another account, no further migration is possible at the moment.",
	"sourceAlreadyMigratedTitle": "Source Account Has Already Been Migrated",
	"title": "Migrate Account Data",
	"tryAgain": "Try Again",
	"tryAgainMessage": "You can try again, but if the problem persists, please contact support."
}
